import { setUserId, getUserId } from '../../utils'
export default {
  namespaced: true,
  state: {
    prov_city: [],
    isLoan: false,
    licenseNoMain: '',
    mobile: '',
    carType: 'new',
    carValue: '',
    carList: [],
    clueId: '',
    userId: getUserId(),
    oldCarDate: '',
    certificate: '',
    purchasesInvoice: '',
    vehicleLicenseFront: '',
    applicantInfo: {},
    insuredInfo: {},
    ownerInfo: {},
    insuredSameApplicant: true,
    ownerSameApplicant: true,
    insuredSameOwner: false,
    insuredIdCardFront: '',
    insuredIdCardBack: '',
    ownerIdCardFront: '',
    ownerIdCardBack: '',
    applicantIdCardFront: '',
    applicantIdCardBack: '',
    vehicleInfo: {},
    q016Req: null, // 查车型的入参
    q017Req: null, // 查报价的入参
    quotation: {}, // 报价结果
    carTicketDto: null,
    rawList: [],
    fileIdList: [],
    jtApplicantName: '',
    jtApplicantCertNo: '',
    isTestJT: true,
    saleCode: '',
    moduleConfig: {},
  },
  mutations: {
    setStateData(state, obj) {
      let { key, data } = obj
      state[key] = data
      if (key === 'userId') {
        setUserId(data)
      }
    },
    setVehicleInfo(state, data) {
      state.vehicleInfo = Object.assign({}, state.vehicleInfo, data)
    },
    setPerson(state, obj) {
      let { key, data } = obj
      state[key] = Object.assign({}, state[key], data)
    },
    setFileIdList(state, item) {
      state.fileIdList.push(item)
    },
    resetCarInfo(state) {
      state.isLoan = false
      state.carValue = ''
      state.carList = []
      state.oldCarDate = ''
      state.certificate = ''
      state.purchasesInvoice = ''
      state.vehicleLicenseFront = ''
      let { transferDate, transferFlag } = state.vehicleInfo
      state.vehicleInfo.transferDate = transferDate
      state.vehicleInfo.transferFlag = transferFlag
      state.carTicketDto = null
      state.q016Req = null
    },
    resetQuotationList(state) {
      state.q017Req = null
      state.quotation = {}
      state.rawList = []
    },
    resetPersonInfo(state) {
      state.ownerSameApplicant = true
      state.insuredSameApplicant = true
      state.insuredSameOwner = false
      state.insuredIdCardFront = ''
      state.insuredIdCardBack = ''
      state.ownerIdCardFront = ''
      state.ownerIdCardBack = ''
      state.applicantIdCardFront = ''
      state.applicantIdCardBack = ''
      state.applicantInfo = {}
      state.insuredInfo = {}
      state.ownerInfo = {}
    },
    setisTestJT(state) {
      state.isTestJT = false
    },
    setModuleConfig(state, moduleConfig) {
      state.moduleConfig = moduleConfig
    },
  },
  getters: {
    isSaleCode(state) {
      return !state.isTestJT ? 'CN192455856622835' : state.saleCode
    },
  },
}
